import { FC, useState } from 'react';
import { DatePicker } from 'antd';
import moment from 'moment';
import classNames from 'classnames';
import CalendarIcon from '../icons/CalendarIcon';
import Paragrapgh from '../Paragrapgh';

interface IOwnProps {
  onChange: (e: moment.Moment | null, value: string) => void;
  onRange?: (e: boolean) => void;
  disabled?: boolean;
  label: string;
  required?: boolean;
  className?: string;
  format?: string;
  defaultValue?: number | null | undefined;
}

const Datepicker: FC<IOwnProps> = ({
  onChange,
  required,
  onRange,
  disabled,
  label,
  className,
  format,
  defaultValue,
}) => {
  const [isError, setIsError] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const datepickerClasses = classNames(className, 'w-100', {
    'ant-picker-input--success': isSuccess,
    'ant-picker-input--error': isError,
  });

  const handleOnChange = (e: moment.Moment | null, value: string) => {
    if (e && onRange && required) {
      setIsSuccess(true);
      setIsError(false);
      onRange(true);
    } else if (onRange && required) {
      setIsSuccess(false);
      setIsError(true);
      onRange(false);
    }

    onChange(e, value);
  };

  return (
    <div className={datepickerClasses}>
      <Paragrapgh
        className='mb-4 d-block'
        size={2}
        color='black'
        align='default'
        fontWeight={400}
      >
        {label}
      </Paragrapgh>
      <DatePicker
        disabled={disabled}
        defaultValue={defaultValue != null ? moment(defaultValue) : undefined}
        value={defaultValue != null ? moment(defaultValue) : null}
        onChange={handleOnChange}
        format={format ?? 'DD/MM/yyyy'}
        suffixIcon={<CalendarIcon color={disabled ? '#C0C0C0' : '#5A607F'} />}
      />
    </div>
  );
};

export default Datepicker;
